import {useState,useEffect,Fragment} from "react";
import "../../components/Modal/Modal.css"
const EmergencyModal = (props)=> {
    const [showModal,setShowModal] = useState(false);
    useEffect(() => {
        setShowModal(props.showModal);
    }, []);
    const closeModal = ()=>{
        setShowModal(false);
    }

    return <Fragment >
        {showModal && <div>
            <div className={"fade modal-backdrop "+ (showModal ? "show" : "")}/>
            <div id="modNewaModal" role="dialog" aria-modal="true" className={"modNewsModal fade modal "+ (showModal ? "show" : "")} tabIndex="-1" >
                <div role="document" className="modal-dialog">
                    <div  className="modal-content">
                        <div role="button" onClick={closeModal} className="yellowCorner" title="סגירה"><i className="fa fa-times"/></div>
                        <div className="emergencyImage"><img src="/_layouts/15/images/Sites/Families/emergency.png" alt="הודעה"/></div>
                        <h3 className="emergencyNewsTitle">{props.emergency.Title}</h3>
                        {props.emergency.FaqRichText1 ? <div className="emergencyNewsContent" dangerouslySetInnerHTML={{__html: props.emergency.FaqRichText1 }}/> : null}
                        <div className="modal-body">
                            <div role="button" onClick={closeModal} className="readMoreDiv emergencyClose" title="סגירה">סגירה</div> 
                        </div>
                    </div>
                </div>
            </div>
         </div>}
     </Fragment>
}
export default (EmergencyModal)